module.exports = __webpack_public_path__ + "static/media/VentureForumLogo.64120836.png";